export default {
    apiUrl: 'http://localhost:3011/api',
};
